import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import InvestorProfileProgress from './InvestorProfileProgress';
import InvestorProfileQuestion from './InvestorProfileQuestion';
import PreviousButton from './PreviousButton';
import { EnrollmentContext } from '../../../../../providers/EnrollmentContextProvider';

const InvestorSurvey = ({
  currentQuestion,
  currentQuestionIndex,
  onAnswer,
  onPreviousQuestionClick,
  profileForm,
}) => {
  const { enrollmentForm, currentStepIndex } = useContext(EnrollmentContext);

  const initialValues = enrollmentForm[`step${currentStepIndex}`];

  return (
    <Form
      form={profileForm}
      layout="vertical"
      initialValues={initialValues}
      hideRequiredMark
      preserve
    >
      <p>
        <b>Para poder asesorarte de mejor forma, necesitamos realizar algunas preguntas</b>
      </p>
      <InvestorProfileProgress currentQuestionIndex={currentQuestionIndex} />
      <InvestorProfileQuestion
        key={`answer-${currentQuestionIndex}`}
        question={currentQuestion}
        onAnswer={onAnswer}
      />
      <PreviousButton onClick={onPreviousQuestionClick}>
        {currentQuestionIndex > 0 ? 'Volver pregunta anterior' : 'Volver'}
      </PreviousButton>
    </Form>
  );
};

InvestorSurvey.propTypes = {
  currentQuestionIndex: PropTypes.number.isRequired,
  currentQuestion: PropTypes.shape().isRequired,
  onAnswer: PropTypes.func.isRequired,
  onPreviousQuestionClick: PropTypes.func.isRequired,
  profileForm: PropTypes.shape().isRequired,
};

export default InvestorSurvey;
